import { ApolloError } from '@apollo/client';

import {
  ContractTemplateListQuery,
  useContractTemplateListQuery,
  useContractTemplateSampleQuery,
} from 'core/graphql';

import { useEsignPermissions } from './useEsignPermissions';

/**
 * ТЗ 0078 — шаблоны договоров: выбор в форме «Новый договор» и справочник.
 */

export type IContractTemplate = ContractTemplateListQuery['contractTemplates'][number];

const EMPTY_TEMPLATES: IContractTemplate[] = [];

/**
 * Шаблоны видов, которые пользователь читает (бэкенд сам сужает по роли).
 * `kind` — один вид (`student`), пусто — все доступные.
 */
export const useContractTemplates = (
  kind: string | null,
  { includeInactive = false, enabled = true } = {},
): {
  templates: IContractTemplate[];
  loading: boolean;
  error?: ApolloError;
} => {
  const { canOpenPage } = useEsignPermissions();
  const { data, loading, error } = useContractTemplateListQuery({
    variables: { kind: kind || null, includeInactive },
    skip: !enabled || !canOpenPage,
    // Шаблоны меняются выкладкой и миграцией, не действием на экране.
    fetchPolicy: 'cache-first',
  });
  return {
    templates: data?.contractTemplates ?? EMPTY_TEMPLATES,
    loading,
    error,
  };
};

/**
 * HTML образца договора на вымышленных данных. `null` у бэкенда — шаблон не
 * виден или у юрлица не заполнен профиль школы (без реквизитов текст не
 * собрать).
 */
export const useContractTemplateSample = (
  templateId: string | null,
): { html: string | null; loading: boolean; failed: boolean } => {
  const { canOpenPage } = useEsignPermissions();
  const { data, loading, error } = useContractTemplateSampleQuery({
    variables: { id: templateId || '' },
    skip: !templateId || !canOpenPage,
    fetchPolicy: 'cache-first',
  });
  return {
    html: data?.contractTemplatePreview ?? null,
    loading,
    failed: Boolean(error),
  };
};
